import { LocationBikeApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { TableState } from '@tanstack/react-table';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import {
    ListLocationBikeResponse,
    LocationBike
} from '@/types/http-payload/locationBike';

export default class LocationBikeStore extends BaseStore {
    locations: LocationBike[] = [];
    locationDetail: any = {};
    listBikeLocation: any[] = [];
    listBikeAvailable: any[] = [];

    locationsPinMap: LocationBike[] = [];

    totalLocationPage: number = 0;
    totalBikePage: number = 0;
    totalLocationRecord: number = 0;
    totalBikeRecord: number = 0;
    api: LocationBikeApi;

    defaultPagingCustom: TableState = {
        pagination: {
            pageIndex: 0,
            pageSize: 6
        },
        sorting: [{}]
    } as TableState;

    locationPaging: TableState = this.defaultPagingCustom;
    bikePaging: TableState = this.defaultPagingCustom;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            locations: observable,
            locationDetail: observable,
            listBikeLocation: observable,
            totalLocationPage: observable,
            totalBikePage: observable,
            locationPaging: observable,
            bikePaging: observable,
            listBikeAvailable: observable,
            totalLocationRecord: observable,
            totalBikeRecord: observable,
            locationsPinMap: observable,
            getAllLocationBike: flow.bound,
            getAllBikeInLocation: flow.bound,
            getLocationBikeDetail: flow.bound,
            getAllBikeAvailableInLocation: flow.bound,
            getLocationsPinMap: flow.bound
        });
        this.api = new LocationBikeApi();
        this.paging = this.locationPaging;
    }

    *getAllLocationBike(searchParams?: any, locationPaging?: TableState) {
        try {
            const payload = {
                ...this.convertPagingFromTableToRequest(
                    locationPaging ?? this.locationPaging
                ),
                ...searchParams
            };
            const res: ResponseData<ListLocationBikeResponse> =
                yield this.rootStore.apiStore.call(
                    this.api,
                    this.api.getAllLocationBike,
                    payload
                );
            if (res.ok) {
                this.locations = res.data.elements;
                this.locationPaging = {
                    ...this.locationPaging,
                    sorting: locationPaging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(
                        res.data.paginate
                    )
                };
                this.totalLocationRecord = res.data.paginate.totalRecord;
                this.totalLocationPage = res.data.paginate.totalPage;
            }
        } catch (error) { }
    }

    *getLocationsPinMap(payload?: any) {
        try {
            const res: ResponseData<ListLocationBikeResponse> =
                yield this.rootStore.apiStore.call(
                    this.api,
                    this.api.getAllLocationBike,
                    payload
                );
            if (res.ok) {
                this.locationsPinMap = res.data.elements;
                return true;
            }
            return false;
        } catch (error) { }
    }

    *getLocationBikeDetail(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getLocationBikeDetail,
                payload
            );
            if (res.ok) {
                this.locationDetail = res.data;
                return res;
            }
        } catch (error) { }
    }

    *getAllBikeInLocation(searchParams?: any, bikePaging?: TableState) {
        try {
            const payload = {
                ...this.convertPagingFromTableToRequest(bikePaging ?? this.bikePaging),
                ...searchParams
            };
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getAllBikeInLocation,
                payload
            );
            if (res.ok) {
                this.listBikeLocation = res.data.elements;
                this.bikePaging = {
                    ...this.bikePaging,
                    sorting: bikePaging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(
                        res.data.paginate
                    )
                };
                this.totalBikeRecord = res.data.paginate.totalRecord;
                this.totalBikePage = res.data.paginate.totalPage;
            }
        } catch (error) { }
    }

    *getAllBikeAvailableInLocation(
        requestParams: any,
        isHideLoading: boolean = true
    ) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getAllBikeAvailableInLocation,
                requestParams,
                { hideLoading: isHideLoading }
            );
            if (res?.ok) {
                this.listBikeAvailable = res.data || [];
                return res.data || [];
            }
        } catch (error) { }
    }

    clean(): void {
        super.clean();
        this.locations = [];
        this.totalLocationRecord = 0;

        this.listBikeLocation = [];
        this.locationDetail = {};

        this.locationsPinMap = [];
    }
}
